module.exports = __webpack_public_path__ + "assets/img/00032.abec4623.png";